import script from "./TasksTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksTable.vue?vue&type=script&setup=true&lang=ts"

import "./TasksTable.vue?vue&type=style&index=0&id=3120f32d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3120f32d"]])

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTd});
